export const breakpoints = {
  base: 0,
  sm: '320px',
  md: '768px',
  lg: '1025px',
  xlg: '1061px',
  xl: '1366px',
  '2xl': '1600px'
};
